/* eslint-disable */

import axios from 'axios';
import { isDeadLinkStatus } from '@/utils/deadLink';
import { takePrefetchedLongUrl } from '@/utils/formPrefetch';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        data: [],
    },
    mutations: {

    },
    actions: {

        async getLongUrl({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});

                // public/index.html starts this exact request while the bundle is still
                // downloading, so the form can render before the `load` event. Strictly
                // matched and fail-open — a miss just falls through to axios below.
                const prefetched = await takePrefetchedLongUrl(payload.urlID, payload);
                if (prefetched) {
                    dispatch('alert/setLoaded', true, {root: true});
                    return prefetched;
                }

                // Optional procedure scope (?aptNum=&codes=) set by the Get Form QR
                // modal so the form's "Teeth #s" field prefills with ONLY the teeth
                // for the procedure this consent covers. Backend re-resolves them and
                // falls back to the unscoped prefill when absent/invalid — so omitting
                // these keeps the historical behaviour exactly.
                const params = {};
                if (payload.aptNum) params.aptNum = payload.aptNum;
                if (payload.codes) params.codes = payload.codes;
                // Tx Presenter's consent wizard scopes by treatment plan instead of
                // appointment; the backend derives this form's codes from the mapping.
                if (payload.txPlan) params.txPlan = payload.txPlan;
                let response = await axios.get(`/get-long-url/${payload.urlID}`, { crossdomain: true, params });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                //dispatch('alert/setMessage', 'Workflow page created successfully!', {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error getting long url:', err);
                if (err.response && isDeadLinkStatus(err.response.status)) {
                    return err.response;
                }
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        }
    }
}